<template>
    <div class="mb-2">
        <p><span :class="{'text-success' : active, 'text-danger': !active}">{{  active ? 'Anzeige online und sichtbar' : 'Anzeige nicht sichtbar' }}</span>

        <span v-if="data && data.next_renew_date"><br><small>Die Anzeige ist bis {{ data.next_renew_date }} aktiv.<br>Nach diesem Datum muss eine erneute Aktivierung der Anzeige durchgeführt werden.<br>Sie erhalten vor Ablauf der Anzeige eine Erinnerungs-Mail.</small></span></p>

        <template v-if="showButton">
            <a v-if="active === false" @click.prevent="onActivate()" href="#" class="btn btn-primary btn-te px-3 me-1">{{ $t('fe.generic.activate') }}</a>
            <a v-if="active === true" @click.prevent="onDeactivate()" href="#" class="btn bg-warning reject btn-te px-3 me-1">{{ $t('fe.generic.deactivate') }}</a>
            <a v-if="active === true && data && data.show_renew_button" @click.prevent="onActivate('renew')" href="#" class="btn btn-primary  renew btn-te text--white px-3 me-1">{{ $t('fe.generic.renew') }}</a>
        </template>

    </div>
</template>
<script>
import axios from 'axios'
import emitter from '../../../plugins/mitt'
export default {
    name: 'ActivateEntry',
    props: {
        showButton: {
            type: Boolean,
            default: true
        },
        data: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
        active:{
            type: Boolean,
            default: null,
        },
        editId:{
            type: String,
            default: null,
        },
        customBackUrl:{
            type: String,
            default: null,
        }
    },
    methods: {
        onActivate: function (operation) {
            if (this.loading) return

            this.loading = true
            axios
                .post(`/api/profile/quota/${this.type}/${this.editId}`,{
                    operation:operation
                })
                .then((response) => {
                    console.log(response)
                    if(response.data && response.data.count_entries !== null){
                        //is not unlimited - ask for activation and show credits

                        if(response.data.count_entries <= 0){
                            //no credits are available

                            Swal.fire({
                                title: this.$t('fe.generic.abo.upgrade_title'),
                                text: this.$t('fe.generic.abo.upgrade_info'),
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: this.$t('fe.generic.abo.confirm'),
                                cancelButtonText: this.$t('fe.generic.abo.decline'),
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    if(response.data.upgrade_url){
                                        let url = response.data.upgrade_url.match(/\?/) ? `${response.data.upgrade_url}&back=` : `${response.data.upgrade_url}?back=`
                                        url = url + encodeURIComponent(this.customBackUrl ? this.customBackUrl : window.location.href)
                                        window.location.href = url
                                    } else {
                                        window.location.href = '/profil'
                                    }

                                } else if (
                                    result.dismiss === Swal.DismissReason.cancel ||
                                    result.dismiss === Swal.DismissReason.backdrop ||
                                    result.dismiss === Swal.DismissReason.close ||
                                    result.dismiss === Swal.DismissReason.esc
                                ) {
                                    this.loading = false
                                }
                            })

                        } else {

                            // credits are available
                            let title = this.$t('fe.generic.entry_activate')
                            let text = this.$t('fe.generic.entry_activate_info',{count_credits: response.data.count_entries})

                            if(operation == 'renew'){
                                title = this.$t('fe.generic.entry_renew')

                                text = this.$t('fe.generic.entry_renew_info',{count_credits: response.data.count_entries})
                                if(response.data.next_expiration_date){
                                    text = this.$t('fe.generic.entry_renew_info_date',{count_credits: response.data.count_entries, next_expiration_date: response.data.next_expiration_date})

                                }

                            }


                            Swal.fire({
                                title: title,
                                text:text,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: this.$t('generic.yes'),
                                cancelButtonText: this.$t('generic.no'),
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.activate(true,operation)
                                } else if (
                                    result.dismiss === Swal.DismissReason.cancel ||
                                    result.dismiss === Swal.DismissReason.backdrop ||
                                    result.dismiss === Swal.DismissReason.close ||
                                    result.dismiss === Swal.DismissReason.esc
                                ) {
                                    this.loading = false
                                }
                            })
                            .catch((error) => {
                                console.log(error)
                                this.loading = false
                                Swal.fire('Fehler', this.$t('generic.error_loading'), 'error')
                            })
                        }


                    } else {
                        //is unlimited - directly activate
                        this.activate(true,operation)
                    }

                })
        },
        onDeactivate: function (values) {
            console.log('deactivating ...')
            if (this.loading) return

            this.loading = true

            this.activate(false)
            this.loading = false
        },
        activate: function (state, operation) {

            axios
                .post(`/api/profile/offers/${this.type}/changeState/${this.editId}`, {
                    activate: state,
                    operation: operation
                })
                .then((response) => {
                    //successfully activated / deactivated
                    this.$emit('stateChanged', state)
                    this.loading = false
                    emitter.emit('boost-update-data', true)

                    if(state) {
                        Swal.fire('Anzeige aktivieren', 'Die Anzeige wurde aktiviert und ist nun für alle sichtbar.', 'success');
                    } else {
                        Swal.fire('Anzeige deaktivieren', 'Die Anzeige wurde deaktiviert und ist nun für keinen mehr sichtbar.', 'info');
                    }

                })
                .catch((error) => {
                    console.log(error)
                    Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                    this.loading = false
                })


        }
    },
    data() {
        return {
            loading: false
        }
    },
}

</script>
<style lang="css" scoped>

</style>
